module.exports = __webpack_public_path__ + "static/media/funtales4kids.0b844913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/funtales4kids.jpg
// module id = 167
// module chunks = 0